import { FrontChat } from "components/FrontChat";

import { Appcues } from "../../components/Appcues";
import { Layout } from "../../components/Layout";

export function Customer() {
  return (
    <>
      <Appcues />
      <FrontChat />
      <Layout />
    </>
  );
}
